/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {SpecialOrderStatusBaseModel} from '../contracts/special-order-status-base.model';
import {Cacheable} from '../../../decorators/cacheable.decorator';

@Injectable({
    providedIn: 'root'
})
export class SpecialOrderStatusService {
    // API endpoints
    private specialOrderStatusBaseUrl = `${environment.specialOrdersBaseUrl}/api/specialOrder/status/base`;

    constructor(protected http: HttpClient) {
    }

    @Cacheable()
    getAllSpecialOrderStatus(): Observable<SpecialOrderStatusBaseModel[]> {
        return this.http.get<SpecialOrderStatusBaseModel[]>(this.specialOrderStatusBaseUrl);
    }
}
